import { useMemo } from 'react';
import { allSupportedFeatures, SupportedFeatures } from '../../utils';

// fontColor is not ready for general use of rte, it's only available in builder-components
export type PossibleFeatureRequest = 'all' | Exclude<SupportedFeatures, 'fontColor'>[] | undefined;

const useFilteredFeatures = (requestedFeatures: Readonly<PossibleFeatureRequest>): SupportedFeatures[] => {
    return useMemo(() => {
        if (requestedFeatures === 'all' || requestedFeatures === undefined) {
            return allSupportedFeatures;
        }

        return requestedFeatures as SupportedFeatures[];
        // should not be reactive because readonly
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useFilteredFeatures;
